import {create} from 'zustand'

export default create((set)=>{
    return {

        test: false,
        playWalkAudio: false,
        startWalkAudio: ()=>{set((state)=>{
            if(!state.playWalkAudio) {
                return {playWalkAudio: true}
            }
            return {}
        })},
        stopWalkAudio: ()=>{set((state)=>{return {playWalkAudio: false}})},

        playLaughterAudio: false,
        startLaughterAudio: ()=>{set(()=>{return {playLaughterAudio: true}})},
        stopLaughterAudio: ()=>{set(()=>{return {playLaughterAudio: false}})},

        playShepardAudio: false,
        startShepardAudio: ()=>{set(()=>{return {playShepardAudio: true }})},
        stopShepardAudio: ()=>{set(()=>{return {playShepardAudio: false}})},

        playTerrorAudio: false,
        startTerrorAudio: ()=>{set(()=>{return {playTerrorAudio: true }})},
        stopTerrorAudio: ()=>{set(()=>{return {playTerrorAudio: false}})},
}})

